import React, { useEffect, useState, useRef } from 'react';
import './brands.css';

import unilever from '../../assets/logos/unilever.png';
import yildizHolding from '../../assets/logos/yildiz-holding.svg';
import mercedes from '../../assets/logos/mercedes.png';
import bristolMyers from '../../assets/logos/bristol-myers.png';
import sephora from '../../assets/logos/sephora.png';
import turkcell from '../../assets/logos/turkcell.png';
import cif from '../../assets/logos/cif.png';
import isbank from '../../assets/logos/isbank.png';
import samsung from '../../assets/logos/samsung.png';
import axe from '../../assets/logos/axe.png';
import berlinIntl from '../../assets/logos/berlin-international.png';
import signal from '../../assets/logos/signal.png';
import papara from '../../assets/logos/papara.png';
import softtech from '../../assets/logos/softtech.png';
import dogan from '../../assets/logos/dogan.png';
import georgian from '../../assets/logos/georgian.png';
import denizbank from '../../assets/logos/denizbank.png';
import omo from '../../assets/logos/omo.png';
import mentora from '../../assets/logos/mentora.png';
import council from '../../assets/logos/council.png';
import redbull from '../../assets/logos/redbull.png';
import dove from '../../assets/logos/dove.png';
import mokaUnited from '../../assets/logos/MU.png';
import diageo from '../../assets/logos/Diageo.png';
import nestle from '../../assets/logos/nestle.png';
import kocfinans from '../../assets/logos/kocfinans.png';
import elidor from '../../assets/logos/elidor.png';
import domestos from '../../assets/logos/Domestos_logo.png';
import ruut from '../../assets/logos/Ruut.png';
import akenerji from '../../assets/logos/Akenerji.png';
import defacto from '../../assets/logos/DeFacto.png';

// Görseldeki sıraya göre tüm marka logoları
const brandLogos = [
  // 1. satır - aktif markalar öne
  { src: mokaUnited, alt: 'Moka United' },
  { src: ruut, alt: 'Ruut' },
  { src: unilever, alt: 'Unilever' },
  { src: yildizHolding, alt: 'Yıldız Holding' },
  { src: mercedes, alt: 'Mercedes-Benz', big: true },
  { src: bristolMyers, alt: 'Bristol Myers Squibb' },
  { src: sephora, alt: 'Sephora' },
  { src: turkcell, alt: 'Turkcell' },
  { src: cif, alt: 'Cif', big: true },
  { src: isbank, alt: 'İş Bankası' },
  { src: samsung, alt: 'Samsung' },
  { src: axe, alt: 'Axe' },
  { src: berlinIntl, alt: 'Berlin International University' },
  { src: signal, alt: 'Signal' },
  { src: papara, alt: 'Papara' },
  { src: softtech, alt: 'Softtech' },
  { src: dogan, alt: 'Doğan' },
  { src: georgian, alt: 'Georgian College' },
  { src: denizbank, alt: 'DenizBank' },
  { src: omo, alt: 'Omo' },
  { src: mentora, alt: 'Mentora Gymnasium' },
  { src: council, alt: 'Council of Europe', big: true },
  { src: redbull, alt: 'Red Bull' },
  { src: dove, alt: 'Dove' },
  { src: diageo, alt: 'Diageo' },
  { src: nestle, alt: 'Nestlé' },
  { src: kocfinans, alt: 'Koçfinans' },
  { src: elidor, alt: 'Elidor', big: true },
  { src: domestos, alt: 'Domestos', big: true },
  { src: akenerji, alt: 'Akenerji' },
  { src: defacto, alt: 'DeFacto' },
];

export default function Brands() {
  const [loaded, setLoaded] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setLoaded(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="brands-section w-full py-20 px-4">
      {/* Başlık */}
      <h2
        style={{ fontWeight: 400 }}
        className="text-3xl md:text-6xl font-Manrope text-[#111111] w-full mb-8 md:mb-24 text-center md:text-left md:pl-20"
      >
        <span className="hidden md:inline">Our Brands</span>
        <span className="inline md:hidden">Brand Portfolio</span>
      </h2>

      {/* Logo grid */}
      <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-10 md:gap-x-5 md:gap-y-14 w-full max-w-screen-xl mx-auto">
        {brandLogos.map((logo) => (
          <div
            key={logo.alt}
            className="flex items-center justify-center basis-[96px] md:basis-[118px] h-12 md:h-20"
          >
            <img
              src={logo.src}
              alt={logo.alt}
              loading="lazy"
              decoding="async"
              className={`${
                logo.big
                  ? 'max-h-14 md:max-h-[72px] max-w-[96px] md:max-w-[118px]'
                  : 'max-h-10 md:max-h-14 max-w-[96px] md:max-w-[118px]'
              } w-auto object-contain brand-img ${loaded ? 'loaded' : ''}`}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
